export const QUIZZ: any = {
  "1": {
    question: "¿Qué es lo más importante para ti?",
    answers: [
      {
        id: 1,
        label: "Cabello fuerte y definido",
        value: "none",
      },
      {
        id: 2,
        label: "Piel sana y rejuvenecida.",
        value: "none",
      },
      {
        id: 3,
        label: "Look fresco y buena cara. ",
        value: "none",
      },
      {
        id: 4,
        label: "Todo es importante",
        value: "none",
      },
    ],
  },
  "2": {
    question: "Elige tu tipo de cabello",
    answers: [
      {
        id: 1,
        label: "Liso",
        value: "none",
      },
      {
        id: 2,
        label: "Ondulado",
        value: "none",
      },
      {
        id: 3,
        label: "Rizado",
        value: "none",
      },
    ],
  },
  "3": {
    question: "¿Cómo definirías tu tipo de piel?",
    answers: [
      {
        id: 1,
        label: "Sensible/Seca ",
        value: "none",
      },
      {
        id: 2,
        label: "Normal",
        value: "none",
      },
      {
        id: 3,
        label: "Mixta/Grasa",
        value: "none",
      },
    ],
  },
  "4": {
    question: "¿Cuál representa mejor el tono de tu piel?",
    answers: [
      {
        id: 1,
        label: "Claro ",
        value: "none",
      },
      {
        id: 2,
        label: "Medio",
        value: "none",
      },
      {
        id: 3,
        label: "Moreno",
        value: "none",
      },
    ],
  },
  "5": {
    question: "¿Cuál es tu subtono de piel?",
    answers: [
      {
        id: 1,
        label:
          "Cálido: La base de tu piel es amarilla/dorada y tiende a estar más favorecida con joyería dorada.",
        value: "none",
      },
      {
        id: 2,
        label:
          "Frío: La base de tu piel es más o menos rosa y tiende a estar más favorecida con joyería plateada.",
        value: "none",
      },
      {
        id: 3,
        label: "Neutro: Le favorece tanto joyería dorada como plateada",
        value: "none",
      },
    ],
  },
};

export const QUIZZ2: any = {
  en: {
    "1": {
      question: "How much time do you like to spend on your beauty routine?",
      answers: [
        {
          id: 1,
          label: "0 - 5 mins",
          value: "1A",
        },
        {
          id: 2,
          label: "5 -15 mins",
          value: "1B",
        },
        {
          id: 3,
          label: "15 - 30 mins",
          value: "1C",
        },
      ],
    },
    "2": {
      question: "Perfect! What is your hair type?",
      answers: [
        {
          id: 1,
          label: "Straight",
          value: "2A",
        },
        {
          id: 2,
          label: "Wavy",
          value: "2B",
        },
        {
          id: 3,
          label: "Curly",
          value: "2C",
        },
      ],
    },
    "3": {
      question: "How old are you?",
      answers: [
        {
          id: 1,
          label: "Under 25",
          value: "3A",
        },
        {
          id: 2,
          label: "25-35",
          value: "3B",
        },
        {
          id: 3,
          label: "35-50",
          value: "3C",
        },
        {
          id: 4,
          label: "50+",
          value: "3D",
        },
      ],
    },
    "4": {
      question: "Perfect! Whats your primary skin concern?",
      answers: [
        {
          id: 1,
          label: "Aging ",
          value: "4A",
        },
        {
          id: 2,
          label: "Acne",
          value: "4B",
        },
        {
          id: 3,
          label: "Dryness",
          value: "4C",
        },
        {
          id: 4,
          label: "Other",
          value: "4D",
        },
      ],
    },
    "5": {
      question: "What products are you most interested in?",
      answers: [
        {
          id: 1,
          label: "Hair",
          value: "5A",
        },
        {
          id: 2,
          label: "Skin",
          value: "5B",
        },
        {
          id: 3,
          label: "Body",
          value: "5C",
        },
        {
          id: 4,
          label: "Makeup",
          value: "5D",
        },
      ],
    },
  },
  es: {
    "1": {
      question: "¿Cuánto tiempo te gusta dedicarle a tu rutina de belleza?",
      answers: [
        {
          id: 1,
          label: "0 - 5 minutos",
          value: "1A",
        },
        {
          id: 2,
          label: "5 -15 minutos",
          value: "1B",
        },
        {
          id: 3,
          label: "15 - 30 minutos",
          value: "1C",
        },
      ],
    },
    "2": {
      question: "Perfecto! ¿Cual es tu tipo de cabello?",
      answers: [
        {
          id: 1,
          label: "Liso",
          value: "2A",
        },
        {
          id: 2,
          label: "Ondulado",
          value: "2B",
        },
        {
          id: 3,
          label: "Rizado",
          value: "2C",
        },
      ],
    },
    "3": {
      question: "¿Cuántos años tienes?",
      answers: [
        {
          id: 1,
          label: "Menos de 25",
          value: "3A",
        },
        {
          id: 2,
          label: "25-35",
          value: "3B",
        },
        {
          id: 3,
          label: "35-50",
          value: "3C",
        },
        {
          id: 4,
          label: "50+",
          value: "3D",
        },
      ],
    },
    "4": {
      question: "Genial! ¿Qué es lo que más te preocupa de tu piel?",
      answers: [
        {
          id: 1,
          label: "Arrugas ",
          value: "4A",
        },
        {
          id: 2,
          label: "Acne",
          value: "4B",
        },
        {
          id: 3,
          label: "Sequedad",
          value: "4C",
        },
        {
          id: 4,
          label: "Otro",
          value: "4D",
        },
      ],
    },
    "5": {
      question: "What products are you most interested in?",
      answers: [
        {
          id: 1,
          label: "Pelo",
          value: "5A",
        },
        {
          id: 2,
          label: "Cara",
          value: "5B",
        },
        {
          id: 3,
          label: "Cuerpo",
          value: "5C",
        },
        {
          id: 4,
          label: "Maquillaje",
          value: "5D",
        },
      ],
    },
  },
  de: {
    "1": {
      question: "How much time do you like to spend on your beauty routine?",
      answers: [
        {
          id: 1,
          label: "0 - 5 mins",
          value: "1A",
        },
        {
          id: 2,
          label: "5 -15 mins",
          value: "1B",
        },
        {
          id: 3,
          label: "15 - 30 mins",
          value: "1C",
        },
      ],
    },
    "2": {
      question: "Perfect! What is your hair type?",
      answers: [
        {
          id: 1,
          label: "Straight",
          value: "2A",
        },
        {
          id: 2,
          label: "Wavy",
          value: "2B",
        },
        {
          id: 3,
          label: "Curly",
          value: "2C",
        },
      ],
    },
    "3": {
      question: "How old are you?",
      answers: [
        {
          id: 1,
          label: "Under 25",
          value: "3A",
        },
        {
          id: 2,
          label: "25-35",
          value: "3B",
        },
        {
          id: 3,
          label: "35-50",
          value: "3C",
        },
        {
          id: 4,
          label: "50+",
          value: "3D",
        },
      ],
    },
    "4": {
      question: "Perfect! Whats your primary skin concern?",
      answers: [
        {
          id: 1,
          label: "Aging ",
          value: "4A",
        },
        {
          id: 2,
          label: "Acne",
          value: "4B",
        },
        {
          id: 3,
          label: "Dryness",
          value: "4C",
        },
        {
          id: 4,
          label: "Other",
          value: "4D",
        },
      ],
    },
    "5": {
      question: "What products are you most interested in?",
      answers: [
        {
          id: 1,
          label: "Hair",
          value: "5A",
        },
        {
          id: 2,
          label: "Skin",
          value: "5B",
        },
        {
          id: 3,
          label: "Body",
          value: "5C",
        },
        {
          id: 4,
          label: "Makeup",
          value: "5D",
        },
      ],
    },
  },
  fr: {
    "1": {
      question: "Combien de temps consacrez-vous à votre routine beauté ?",
      answers: [
        {
          id: 1,
          label: "0 à 5 minutes",
          value: "1A",
        },
        {
          id: 2,
          label: "5 à 15 minutes",
          value: "1B",
        },
        {
          id: 3,
          label: "15 à 30 minutes",
          value: "1C",
        },
      ],
    },
    "2": {
      question: "Parfait ! Quel est votre type de cheveux ?",
      answers: [
        {
          id: 1,
          label: "Lisses",
          value: "2A",
        },
        {
          id: 2,
          label: "Ondulés",
          value: "2B",
        },
        {
          id: 3,
          label: "Bouclés",
          value: "2C",
        },
      ],
    },
    "3": {
      question: "Quel âge avez-vous?",
      answers: [
        {
          id: 1,
          label: "Moins de 25 ans",
          value: "3A",
        },
        {
          id: 2,
          label: "25-35",
          value: "3B",
        },
        {
          id: 3,
          label: "35-50",
          value: "3C",
        },
        {
          id: 4,
          label: "50+",
          value: "3D",
        },
      ],
    },
    "4": {
      question:
        "Parfait ! Quelle est votre principale préoccupation en ce qui concerne votre peau ?",
      answers: [
        {
          id: 1,
          label: "Rides et vieillissement de la peau",
          value: "4A",
        },
        {
          id: 2,
          label: "Acné et cicatrices",
          value: "4B",
        },
        {
          id: 3,
          label: "Sécheresse",
          value: "4C",
        },
        {
          id: 4,
          label: "Autres",
          value: "4D",
        },
      ],
    },
    "5": {
      question: "Quels sont les produits qui vous intéressent le plus ?",
      answers: [
        {
          id: 1,
          label: "Pour cheveux",
          value: "5A",
        },
        {
          id: 2,
          label: "Pour la peau",
          value: "5B",
        },
        {
          id: 3,
          label: "Pour le corps",
          value: "5C",
        },
        {
          id: 4,
          label: "Maquillage",
          value: "5D",
        },
      ],
    },
  },
  it: {
    "1": {
      question: "Quanto tempo ti piace dedicare alla tua routine di bellezza?",
      answers: [
        {
          id: 1,
          label: "0 - 5 minuti",
          value: "1A",
        },
        {
          id: 2,
          label: "5 -15 minuti",
          value: "1B",
        },
        {
          id: 3,
          label: "15 - 30 minuti",
          value: "1C",
        },
      ],
    },
    "2": {
      question: "Perfetto! Qual è il tuo tipo di capelli?",
      answers: [
        {
          id: 1,
          label: "Lisci",
          value: "2A",
        },
        {
          id: 2,
          label: "Mossi",
          value: "2B",
        },
        {
          id: 3,
          label: "Ricci",
          value: "2C",
        },
      ],
    },
    "3": {
      question: "Quanti anni hai?",
      answers: [
        {
          id: 1,
          label: "Sotto i 25 anni",
          value: "3A",
        },
        {
          id: 2,
          label: "25-35",
          value: "3B",
        },
        {
          id: 3,
          label: "35-50",
          value: "3C",
        },
        {
          id: 4,
          label: "50+",
          value: "3D",
        },
      ],
    },
    "4": {
      question: "Perfetto! Qual è il tuo problema principale della pelle?",
      answers: [
        {
          id: 1,
          label: "Invecchiamento ",
          value: "4A",
        },
        {
          id: 2,
          label: "Acne",
          value: "4B",
        },
        {
          id: 3,
          label: "Secchezza",
          value: "4C",
        },
        {
          id: 4,
          label: "Altro",
          value: "4D",
        },
      ],
    },
    "5": {
      question: "Quali sono i prodotti che ti interessano di più?",
      answers: [
        {
          id: 1,
          label: "Capelli",
          value: "5A",
        },
        {
          id: 2,
          label: "Pelle",
          value: "5B",
        },
        {
          id: 3,
          label: "Corpo",
          value: "5C",
        },
        {
          id: 4,
          label: "Makeup",
          value: "5D",
        },
      ],
    },
  },
};
/*
¿Estás embarazada o en lactancia?
*/

export const PRODUCTS_API_BASE_URL: string =
  "https://proxy.cocunat.com/products-new/products/";
export const PHOTOS_URL: string = "https://global.cocunat.com/club-microsite/";
export const CART_API_BASE_URL: string = "https://cocunatapi.net/carts/";
export const API_BASE_URL: string = "https://rest-api.cocunat.com/v2/";
export const REGIONS_API_BASE_URL: string =
  "https://proxy.cocunat.com/regions/";
export const ADD_LEADS_URL: string = "https://cocunatapi.net/leads-api/";
